export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

// export const sync = async () => null;
export const sync = () => new Promise(resolve => setTimeout(resolve, 100));
